export default __webpack_public_path__ + "static/media/vip-1.f0de4efe.svg";